module.exports = __webpack_public_path__ + "img/boat30.5ecb4686.png";